import { IconButton } from '@doordash/component-button';
import PropTypes from 'prop-types';
import React from 'react';

var CloseButton = function CloseButton(_ref) {
  var closeButtonAccessibilityLabel = _ref.closeButtonAccessibilityLabel,
      onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(IconButton, {
    iconType: IconButton.IconTypes.Close,
    onClick: onClose,
    accessibilityLabel: closeButtonAccessibilityLabel
  });
};

CloseButton.propTypes = {
  closeButtonAccessibilityLabel: PropTypes.string,
  onClose: PropTypes.func
};
export default CloseButton;